// @ts-ignore
import React from "react"
import utils from "./Utils"

export default {
  utils,
}
